import {
  SET_CONTEXT_MENU_VISIBILITY,
  SET_SELECTED_ITEM_ID,
  UPDATE_SELECTED_ITEMS,
  CLEAR_SELECTED_ITEMS,
  SET_MULTIPLE_SELECTION,
} from "./types";

export function setContextMenuVisibility(data: any) {
  return {
    type: SET_CONTEXT_MENU_VISIBILITY,
    data
  }
}

export function setSelectedItemId(data: string) {
  return {
    type: SET_SELECTED_ITEM_ID,
    data
  }
}

export function updatedSelectedItems(data: string[]) {
  return {
    type: UPDATE_SELECTED_ITEMS,
    data
  }
}

export function clearSelectedItems() {
  return {
    type: CLEAR_SELECTED_ITEMS,
  }
}

export function setMultipleSelection(data: boolean) {
  return {
    type: SET_MULTIPLE_SELECTION,
    data
  }
}
